import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';

export default class PcsCardEventModel extends Model {
  @attr declare provider: string;
  @attr declare providerEvent: string;
  @attr declare event: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-card', { async: false, inverse: 'pcsCardEvents' })
  declare pcsCard: PcsCardModel;

  // Polymorphic relationships - source and sink
  // These reference the originating record (e.g., PcsAuthorization) and target record (e.g., TasAssistance)
  @attr declare sourceId: string;
  @attr declare sourceType: string;
  @attr declare sinkId: string;
  @attr declare sinkType: string;

  [Type] = 'pcs-card-event' as const;
}
